import React from "react"
import { Modal, Button, Col } from "react-bootstrap"
import {
  checkboxStatusUpdate,
  updateUiData,
  submitClaim,
} from "../redux/actions"
import { useSelector, useDispatch, shallowEqual } from "react-redux"
import { pleaseAgreeAlert } from "../services/sweetalertService"
import { navigate } from "gatsby"

const Declaration = props => {
  const dispatch = useDispatch()
  const uiData = useSelector(state => state.uiData, shallowEqual)
  const claimData = useSelector(state => state.claimData, shallowEqual)
  const isAgree = useSelector(
    state => state.uiData.checkBoxStatus.isAgree,
    shallowEqual
  )

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton className="borderBottomUnset">
        <Modal.Title id="contained-modal-title-vcenter">
          Declaration, Authorization {"&"} Customer's Data Privacy Consent
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-justify">
          <span className="paragraphTitle">[Declaration]</span>{" "}
          <span className="paragraphText">
            I/We declare that the information given in this form is true and
            correct to the best of my knowledge and belief. I/We understand that
            all information and supporting documents may be subject to review by
            Etiqa and Etiqa shall reserves all rights to recover any and all
            amounts if for any reason any claim is found to be fraudulent. Etiqa
            shall also reserve the right to pursue any actions at law or in
            equity that it deems appropriate in dealing with such fraudulent
            activity.
          </span>
        </p>
        <p className="text-justify">
          <span className="paragraphTitle">[Authorization]</span>{" "}
          <span className="paragraphText">
            I/We hereby consent to and authorize the medical practitioner
            involved in the claimant’s care to discuss and disclose treatment
            details and discharge arrangements with and to Etiqa Insurance Pte
            Ltd. I/We agree that a copy of this consent shall have the validity
            of the original.
          </span>
        </p>
        <p className="text-justify">
          <span className="paragraphTitle">
            [Customer’s Data Privacy Consent]
          </span>{" "}
          <span className="paragraphText">
            I/We further declared that the information written in this claim
            form or held by Etiqa Insurance Pte Ltd whether contained in my/our
            insurance application or otherwise obtained may be used and
            disclosed to your authorised staff, associated individuals and/or
            companies or any independent third parties (within or outside
            Singapore) who will provide claims administrative, advice and/or
            information or claims services in relation to my/our claim. I/We
            understand my/our data that may also be used for audit, business
            analysis and reinsurance purposes.
          </span>
        </p>

        {/* --- Remove 3 direct credit paragraphs.  eClaim is accessed from Tiq Connect only, hence, owner/claimant will be paid via eWallet */}

        {/* <p className="text-justify">
          <span className="paragraphTitle">[Direct Credit]</span>{" "}
          <span className="paragraphText">
            I/We confirm that there had not been any change to my tax residency
            status or any circumstances which affects my/our tax residency
            status and undertake to provide Etiqa with a suitably updated
            self-certification and documentation otherwise.
          </span>
        </p>
        <p className="text-justify">
          <span className="paragraphTitle">[Direct Credit]</span>{" "}
          <span className="paragraphText">
            Confirm that the payment information provided by me/us in this form
            is true and correct and undertake to immediately inform the Company
            of any change in the same and will not hold the Company liable in
            the event that any payment transaction into my Account is delayed or
            cannot be effected due to incorrect or incomplete information being
            provided in this form, and/or for any other reason beyond the
            reasonable control of the Company.
          </span>
        </p>
        <p className="text-justify">
          <span className="paragraphTitle">[Direct Credit]</span>{" "}
          <span className="paragraphText">
            Notwithstanding the above, Etiqa Insurance Pte Ltd reserves the
            right to release payment to me/us by cheque if we are unable to
            payout the claim by direct credit.
          </span>
        </p> */}
        <Col
          xs={12}
          md={12}
          className={"marginTop10px CheckBox " + (isAgree ? "tick" : "")}
          onClick={() => dispatch(checkboxStatusUpdate("isAgree"))}
          role="button"
          tabIndex="0"
        >
          {"I/We agree to abide by the terms & conditions."}
        </Col>
      </Modal.Body>
      <Modal.Footer className="borderTopUnset">
        {/* <Button onClick={props.onHide}>Close</Button> */}
        <Button
          className="btnSubmitForm fontWeightBold float-right"
          type="submit"
          onClick={() => {
            if (isAgree) {
              props.onHide()

              dispatch(updateUiData("showLoading", true))
              dispatch(updateUiData("maxPageNumber", 3))
              dispatch(submitClaim(claimData, uiData))
            } else {
              pleaseAgreeAlert()
            }
          }}
          // disabled={isSubmitting}
        >
          <b>Submit</b>
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default Declaration
